// Keep a single FourSixty embed and move it between responsive placement targets.
// CSS-hidden desktop and mobile copies would still execute both embeds' scripts, potentially causing duplicate
// initialization, requests, event listeners, and analytics impressions.

if ( !customElements.get('foursixty-placement') ) {
  customElements.define('foursixty-placement', class FourSixtyPlacement extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.mobileMediaQuery = window.matchMedia('(max-width: 999px)');

      this.mobileMediaQuery.addEventListener('change', () => this.updatePlacement(), {
        signal: this.abortController.signal
      });

      this.updatePlacement();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    updatePlacement() {
      const sectionId = this.getAttribute('section-id');
      const mobilePlacement = this.getAttribute('mobile-placement') || 'images';
      const placement = this.mobileMediaQuery.matches ? mobilePlacement : 'images';
      const targets = document.querySelectorAll(`[data-foursixty-target="${placement}-${sectionId}"]`);
      const paymentTermsTarget = placement === 'buy_buttons'
        ? document.querySelector(`[data-foursixty-target="payment_terms-${sectionId}"]`)
        : null;
      const target = paymentTermsTarget || targets[targets.length - 1];

      if (target && this.parentElement !== target) {
        target.append(this);
      }
    }
  });
}
